// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1C4nn","name":"ConsentHeader_name__2HKan","birthday":"ConsentHeader_birthday__3jLDv","skeleton":"ConsentHeader_skeleton__9vFRg"};